import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";

interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/admin/payment/advertiser' // 광고목록 조회

const fetchKey = (itemId:any) =>
	`${M_KEY}${itemId ? `/${itemId}` : ''}`;

export function useAdminPaymentADDeductedList(itemId:any) {
	const { data: token } = useToken();

	const KEY = fetchKey(itemId);


	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate, isLoading } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });

	return { adminPaymentADDeductedList: data?.list, mutateAdminPaymentADDeductedList: mutate, total: data?.total, isLoading };
}

async function fetchAPI(KEY:string, token:any): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return {list: response.result?.result?.list || [], total: response.result?.result?.totalCount}
	} catch (error) {
		console.error('Failed to fetch Admin Payment AD Deducted List:', error);
		return { list: [], total: 0 };
	}
}